<template>
  <div class="list-skus">
    <loading v-if="!skus"></loading>
    <div v-else="" class="row" >
      <div v-for="sku in skus" class="col-sm-6 col-md-4" :class="{ 'col-lg-3': parent == 'catalog'}">
        <router-link :to="getRouteParams(sku)" :id="'sku-' + sku.id">
          <div class="product-catalog-item with-prices">
            <div class="chevron visible-xs"><i class="fa fa-angle-right fa-3x"></i></div>
            <div class="img-container">
              <img :src="sku.image" :alt="sku.title + ' - Loca.Shop'" class="img-responsive-center">
            </div>
            <h4>{{ sku.title }}</h4>
            <p>
              <template v-if="parseInt(sku.quantity_companies) == 1">Em <b>{{ sku.unique_company }}</b> por:</template>
              <template v-else="">Em <b>{{ sku.quantity_companies }} locadoras</b> a partir de:</template>
            </p>
            <p class="prices">
              <template v-if="sku.price_day > 0"><strong class="text-success">{{ sku.price_day | money }}</strong> <small>por dia</small><br></template>
              <template v-if="sku.price_week > 0"><strong class="text-success">{{ sku.price_week | money }}</strong> <small>por semana</small><br></template>
              <template v-if="sku.price_biweek > 0"><strong class="text-success">{{ sku.price_biweek | money }}</strong> <small>por quinzena</small><br></template>
              <template v-if="sku.price_month > 0"><strong class="text-success">{{ sku.price_month | money }}</strong> <small>por mês</small></template>
            </p>
          </div>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import _ from 'lodash'

  export default{
    name: 'ListSkus',
    props: ['parent', 'parentId', 'filters'],
    data () {
      return {
        skus: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        city: state => state.city
      })
    },
    mounted () {
      this.load()
    },
    watch: {
      filters: function (newFilters) {
        this.filter = newFilters
        this.load()
      }
    },
    methods: {
      getRouteParams (sku) {
        let routeData = {}
        routeData = {
          name: 'sku',
          params: {
            categorySlug: sku.product.subcategory.category.slug,
            subcategorySlug: sku.product.subcategory.slug,
            productSlug: sku.product.slug,
            skuSlug: sku.slug,
            skuId: sku.id
          }
        }
        return routeData
      },
      load () {
        const city = this.city ? '&city_id=' + this.city.id : ''
        const filters = this.filters ? '&filters=' + _.join(this.filters, '_') : ''
        const uri = '?parent=' + this.parent + '&id=' + this.parentId + city + filters
        this.skus = false
        this.$http.get('skus' + uri)
          .then((response) => {
            this.skus = response.data.data
            this.$emit('loaded', 'skus')
          })
      },
      ...mapActions([])
    }
  }
</script>


// WEBPACK FOOTER //
// ListSkus.vue?0879ad70